<!-- src/components/TreeItem.vue -->
<script setup lang="ts">
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const props = defineProps<{
  item: any;
  path: string[];
}>();

const router = useRouter();
const route = useRoute();

const isActive = computed(() => {
  return route.path.includes(props.item.id);
});

const navigateToItem = () => {
  const newPath = [...props.path, props.item.id].join('/');
  router.push(`/help/${newPath}`);
};
</script>

<template>
  <li>
    <div
        @click="navigateToItem"
        :class="{
        'font-bold': item.children,
        'cursor-pointer': true,
        'hover:text-blue-600': true,
        'text-blue-600': isActive
      }"
    >
      {{ item.title }}
    </div>
    <ul v-if="item.children" class="ml-4">
      <TreeItem
          v-for="child in item.children"
          :key="child.id"
          :item="child"
          :path="[...path, item.id]"
      />
    </ul>
  </li>
</template>